import { WithGlobalCss } from "@sgwt-widget/core";
import { Component, h } from "preact";

export interface ErrorMessageProps {
  message?: string;
}
export const UserActionOnAuthErrorMessage = class extends Component<
  ErrorMessageProps
> {
  public constructor() {
    super();
  }

  public render(): JSX.Element {
    return (
      <WithGlobalCss>
        <div class="text-warning">
          {this.props.message != undefined
            ? this.props.message
            : "You must have a valid C-Profit account to see this content. Please go to POPS to request your access."}
        </div>
      </WithGlobalCss>
    );
  }
};
